/** Backend agency category identifiers */
export const AGENCY_CATEGORIES = {
  CLOTHES: "clothes",
  CARS: "cars",
  WEDDING: "wedding",
  REAL_ESTATE: "real-estate",
};

/** Human-readable labels for UI */
export const CATEGORY_LABELS = {
  [AGENCY_CATEGORIES.CLOTHES]: "Clothes",
  [AGENCY_CATEGORIES.CARS]: "Cars",
  [AGENCY_CATEGORIES.WEDDING]: "Wedding",
  [AGENCY_CATEGORIES.REAL_ESTATE]: "Real Estate",
};

/** Ordered list for tabs and selectors */
export const CATEGORY_LIST = [
  AGENCY_CATEGORIES.CLOTHES,
  AGENCY_CATEGORIES.CARS,
  AGENCY_CATEGORIES.REAL_ESTATE,
  AGENCY_CATEGORIES.WEDDING,
];

/** API path segments (backend routes) */
export const CATEGORY_API_PATHS = {
  [AGENCY_CATEGORIES.CLOTHES]: "/api/v1/clothes",
  [AGENCY_CATEGORIES.CARS]: "/api/v1/car",
  [AGENCY_CATEGORIES.WEDDING]: "/api/v1/wedding",
  [AGENCY_CATEGORIES.REAL_ESTATE]: "/api/v1/realstate",
};

/** Map legacy UI/API values to new category keys */
export const LEGACY_CATEGORY_MAP = {
  Clothing: AGENCY_CATEGORIES.CLOTHES,
  Clothes: AGENCY_CATEGORIES.CLOTHES,
  clothes: AGENCY_CATEGORIES.CLOTHES,
  Car: AGENCY_CATEGORIES.CARS,
  Cars: AGENCY_CATEGORIES.CARS,
  cars: AGENCY_CATEGORIES.CARS,
  car: AGENCY_CATEGORIES.CARS,
  Wedding: AGENCY_CATEGORIES.WEDDING,
  "Wedding Venues": AGENCY_CATEGORIES.WEDDING,
  wedding: AGENCY_CATEGORIES.WEDDING,
  RealState: AGENCY_CATEGORIES.REAL_ESTATE,
  "Real State": AGENCY_CATEGORIES.REAL_ESTATE,
  "real-estate": AGENCY_CATEGORIES.REAL_ESTATE,
  realstate: AGENCY_CATEGORIES.REAL_ESTATE,
};

export const normalizeCategory = (value) => {
  if (!value) return AGENCY_CATEGORIES.CLOTHES;
  return LEGACY_CATEGORY_MAP[value] || value;
};

export const getCategoryLabel = (category) =>
  CATEGORY_LABELS[normalizeCategory(category)] || category;

/** Values stored on user/product records in the current API */
export const toApiCategoryValue = (category) => {
  const key = normalizeCategory(category);
  const map = {
    [AGENCY_CATEGORIES.CLOTHES]: "Clothing",
    [AGENCY_CATEGORIES.CARS]: "Car",
    [AGENCY_CATEGORIES.WEDDING]: "Wedding",
    [AGENCY_CATEGORIES.REAL_ESTATE]: "RealState",
  };
  return map[key] || category;
};

export const getCategoryBadgeClass = (category) => {
  const key = normalizeCategory(category);
  const map = {
    [AGENCY_CATEGORIES.CLOTHES]: "badge-clothes",
    [AGENCY_CATEGORIES.CARS]: "badge-cars",
    [AGENCY_CATEGORIES.WEDDING]: "badge-wedding",
    [AGENCY_CATEGORIES.REAL_ESTATE]: "badge-realestate",
  };
  return map[key] || "badge-default";
};
